import * as React from 'react';
import { Header4 } from '@cian/ui-kit/typography';
import classNames from 'classnames';
import * as styles from './Button.css';

export function ButtonLink(props: React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  const { href, children } = props;

  return (
    <a className={classNames(styles['button'])} href={href} target="_blank" rel="noreferrer">
      <Header4 color="white_100" fontWeight="bold">
        {children}
      </Header4>
    </a>
  );
}
